export default __webpack_public_path__ + "static/media/DashboardNavOpen.9d5dc614.png";